import * as towers from "../../common/towers";
import { createSelector } from "reselect";

const getExpiringProgramLayers = (state) =>
  state.input.expiringProgram?.layers || [];

export const getExpiringLayers = createSelector(
  [getExpiringProgramLayers],
  towers.fillAttachmentInLayers
);

/** Normalise layer so computed fields work for external/loaded data with alternate keys. */
const _normaliseLayer = (layer) => {
  const grossPremium =
    layer.grossPremium ?? layer.marketGwp ?? layer.marketGrossWrittenPremium;
  if (grossPremium === undefined) return layer;
  return { ...layer, grossPremium };
};

const _layerToGrossPPM = (layer) => {
  const limit = layer.limit;
  const grossPremium =
    layer.grossPremium ?? layer.marketGwp ?? layer.marketGrossWrittenPremium;
  if (limit != null && grossPremium != null && limit !== 0) {
    return (grossPremium / limit) * 1e6;
  }
  return layer.grossPPM ?? null;
};

const _calculateLayerFields = (layer) => {
  const normalised = _normaliseLayer(layer);
  return {
    ...normalised,
    grossPPM: _layerToGrossPPM(normalised),
  };
};

export const getExpiringProgramLayersToDisplay = createSelector(
  [getExpiringLayers],
  (layers) =>
    towers
      .addEmptyLayerWithAttachment(layers)
      .map(_calculateLayerFields)
      .reduce((layersBelow, layer) => {
        const layerBelow = layersBelow[layersBelow.length - 1] ?? null;

        const calculateRelativeToLayerBelow = (key) =>
          layer[key] != null && layerBelow?.[key]
            ? layer[key] / layerBelow[key]
            : null;

        return [
          ...layersBelow,
          {
            ...layer,
            grossPPMRelativeToLayerBelow: calculateRelativeToLayerBelow(
              "grossPPM"
            ),
          },
        ];
      }, [])
);
